import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { AxiosError, AxiosInstance } from 'axios'

import { recursiveCamelCase } from './helper'
import useAxios from './useAxios'
import { SearchCategoryT } from 'modules/AppsSelector/AppsGlobalSearch'

export default function useGlobalSearchAutocomplete(
  type: SearchCategoryT,
  searchString: string,
  extraProps?: UseQueryOptions<any, any>
) {
  const axios = useAxios()

  return useQuery<string[], AxiosError>(
    ['globalSearch', 'autocomplete', type, searchString],
    () => searchAutocomplete(axios, type, searchString),
    { enabled: searchString !== '', ...extraProps }
  )
}

export const searchAutocomplete = async (
  axios: AxiosInstance,
  type: SearchCategoryT,
  searchString: string
): Promise<string[]> => {
  return axios
    .get(
      `/autocomplete/${encodeURIComponent(type)}/?q=${encodeURIComponent(searchString)}`
    )
    .then((res) => recursiveCamelCase(res.data))
}
